/**
 * From notes (CT-5724): the meeting insights of a record and the Concierge's
 * readings (summaries, topics, interpretations). Email and call summaries live
 * on the Timeline, not here.
 *
 * The path is ASSUMED, `TODO(CT-5724 / backend)`.
 */

import { validateApiResponse } from '../shared/utils/apiResponse.js';
import { request } from './mockTransport.js';

const mapNote = (raw = {}) => ({
  id: raw.id ?? '',
  kind: raw.kind ?? null,
  title: raw.title ?? null,
  text: raw.text ?? '',
  origin: raw.origin ?? null,
});

export const mapApiNotesFeedToUi = (raw = {}) => ({
  insights: (raw.insights ?? []).map((insight) => ({
    id: insight.id ?? '',
    title: insight.title ?? '',
    subtitle: insight.subtitle ?? null,
    unconfirmedClaims: insight.unconfirmed_claims ?? insight.unconfirmedClaims ?? 0,
    recordLabel: insight.record_label ?? insight.recordLabel ?? null,
    occurredAt: insight.occurred_at ?? insight.occurredAt ?? null,
    file: insight.file ?? null,
    topics: (insight.topics ?? []).map(mapNote),
  })),
  other: (raw.other ?? []).map(mapNote),
});

/**
 * TODO(CT-5724 / backend): `POST /v0/profile/notes-feed/list` with `{ entity_type,
 * entity_id, quick_filter, search: { query, fields } }`.
 */
export const listNotesFeed = async ({ entityType, entityId, quickFilter = 'all', search } = {}) => {
  const response = await request('/v0/profile/notes-feed/list', {
    entity_type: entityType,
    entity_id: entityId,
    quick_filter: quickFilter,
    ...(search ? { search } : {}),
  });
  return validateApiResponse(response, 'Failed to load the notes');
};
